import { render, staticRenderFns } from "./forgetPwd.vue?vue&type=template&id=352e3412&scoped=true&"
import script from "./forgetPwd.vue?vue&type=script&lang=js&"
export * from "./forgetPwd.vue?vue&type=script&lang=js&"
import style0 from "./forgetPwd.vue?vue&type=style&index=0&id=352e3412&scoped=true&lang=less&"
import style1 from "./forgetPwd.vue?vue&type=style&index=1&id=352e3412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e3412",
  null
  
)

export default component.exports